'use strict';

require('../../style/index.css');

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/lib/tabs/style/css.js
// module id = lIul
// module chunks = 0